import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';

// Encabezado de sección reutilizable: caja de acento (tint del tenant) +
// título uppercase + línea divisoria + contador opcional a la derecha.
// El glyph de ícono se difiere (react-pdf no rinde lucide); v1 usa caja sólida.
function SectionHeader({ title, count }) {
  const { colors, FONT } = useTemplateColors();
  const styles = StyleSheet.create({
    row: { flexDirection: 'row', alignItems: 'center', gap: '0.2cm', marginBottom: '0.2cm' },
    ix: { width: 9, height: 9, borderRadius: 2, backgroundColor: colors.primary },
    title: {
      fontSize: 9,
      fontFamily: FONT.bold,
      color: colors.ink || colors.darkText,
      textTransform: 'uppercase',
      letterSpacing: 0.4,
    },
    line: { flex: 1, height: 1, backgroundColor: colors.border },
    count: { fontSize: 8, fontFamily: FONT.base, color: colors.muted },
  });
  return (
    <View style={styles.row}>
      <View style={styles.ix} />
      <Text style={styles.title}>{title}</Text>
      <View style={styles.line} />
      {count ? <Text style={styles.count}>{count}</Text> : null}
    </View>
  );
}

export default SectionHeader;
